<template>
  <div class="continer">
    <div class="center">
      <h1>通辽大地建设工程施工图审查有限责任公司</h1>
    </div>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="stylus" scoped>
.continer
  width 100%
  height 135px
  .center
    width 1200px
    margin 0 auto
    font-size 46px 
    line-height 160px
    text-align left
    overflow hidden
    h1  
      font-weight bold
      // vertical-align middle
      // display block

</style>